// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"279":"3089a750","596":"3089a750","632":"3089a750","666":"3089a750","675":"077ff1a6","718":"3089a750","818":"3089a750"}[chunkId] + ".css";
};